import React, { Component, useState } from 'react'
import { Container, Row, Col, Input } from 'reactstrap'
import FinancialAccountList from "./FinancialAccountList"
import './FinancialAccountListContainer.css'
import NewFinancialAccountModal from "./NewFinancialAccountModal"
import RestrictedSection from "../../Components/RestrictedSection"
import TaxManagementTab from "../TaxManagement/TaxManagementTab"
import ListingTabs from "../../Material/ListingTabs"
import AdvancedFilters from '../../Filters/AdvancedFilters'
import AdvancedFiltersTrigger from '../../Filters/AdvancedFiltersTrigger'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'
import { useAdvancedFilters } from '../../Filters/filterUrl'

const tabs = [
    { id: "#financeAccounts", name: "Finance Accounts" },
    { id: "#taxes", name: "Sales Tax Management" }
]

// Advanced filters live in the URL (useAdvancedFilters); this control just hosts
// the popover open/close state so the class container can render it. Only used
// on this standalone listing page -- the embedded BranchDetailTabs financial
// accounts view never renders it and never passes `filters` down.
function FinancialAccountAdvancedFiltersControl({ activeFilters, onApply }) {
    const [isOpen, setIsOpen] = useState(false)
    return (
        <>
            <AdvancedFiltersTrigger compact count={activeFilters.length} onClick={() => setIsOpen(!isOpen)} />
            {isOpen && (
                <AdvancedFilters
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    entity="financial_account"
                    context={null}
                    activeFilters={activeFilters}
                    onApply={onApply}
                />
            )}
        </>
    )
}

class FinancialAccountListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchTerm: null,
            orderBy: "-id",
            // This container is now nested inside OrganizationPage's own tab shell, as its
            // "Billing Management" panel -- that shell already owns window.location.hash for
            // its own tab strip (#billing_management). This sub-tab used to write its own
            // ids (#financeAccounts / #taxes) straight into the hash too, which clobbered the
            // shell's hash on every mount and switch: the URL would end up reading
            // "/organization/#financeAccounts", a hash the shell doesn't recognise, so
            // sharing or reloading it landed back on the Tenants tab instead of Billing
            // Management. Tracking the sub-tab in local component state instead sidesteps the
            // collision entirely -- it's no longer independently deep-linkable, but nothing
            // requires that; only the shell's own tab needs to stay linkable.
            activeTab: tabs[0].name
        }
    }

    changeTab = (value) => {
        this.setState({ activeTab: value })
    }

    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (value === "null") {
            value = null
        }
        // To change string inputs to boolean because only strings can be passed to html options
        if (e.target.dataset.type) {
            if (value === "false") {
                value = false
            } else {
                value = true
            }
        }

        this.setState({ [name]: value })
    };

    updateOrderBy = (name) => {
        name = name && name.includes(".") ? name.replace(".", "__") : name
        this.setState({ orderBy: this.state.orderBy === name ? "-" + name : name })
    }

    toggleModal = (modalName) => {
        if (this.state.openModal !== modalName) {
            this.setState({ openModal: modalName })
        } else {
            this.setState({ openModal: "" })
        }
    }

    renderContent = () => {
        switch (this.state.activeTab) {
            case "Sales Tax Management":
                return <TaxManagementTab />
            case "Finance Accounts":
                return (
                    <>
                        <Row className="align-items-center">
                            <Col xs={4}>
                                <span className="driver-search-filter">
                                    <Input type="text" name="searchTerm" placeholder="Search" onChange={this.updateInput} />
                                    <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                                </span>
                            </Col>
                            <Col xs="auto" className="p-0">
                                <FinancialAccountAdvancedFiltersControl activeFilters={this.props.advancedFilters} onApply={this.props.setAdvancedFilters} />
                            </Col>
                            <Col className="text-right">
                                <a id="newFinancialAccount" className="driver-list-button" onClick={() => this.toggleModal("NewFinancialAccount")}>
                                    New Financial Account | <i className="fa fa-plus" aria-hidden="true"></i>
                                </a>
                                {this.state.openModal === "NewFinancialAccount" && <NewFinancialAccountModal handleClose={() => this.toggleModal("")} open={this.state.openModal === "NewFinancialAccount"} />}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} className="mt-2 search-filter-container">
                                <AppliedAdvancedFilters entity="financial_account" context={null} />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col className="bos-object-section-wrapper">
                                <FinancialAccountList currentUser={this.props.currentUser} searchTerm={this.state.searchTerm} orderBy={this.state.orderBy} updateOrderBy={this.updateOrderBy} filters={this.props.advancedFilters} />
                            </Col>
                        </Row>
                    </>
                )
            default:
                return null
        }
    }

    render() {
        return (
            <RestrictedSection requiredPermission="view_financialaccount">
                <Container fluid className="bos-listing-container" >
                    <ListingTabs
                        tabs={tabs}
                        activeTab={this.state.activeTab}
                        activeValueKey="name"
                        onChange={this.changeTab}
                    />
                    {
                        this.renderContent()
                    }

                </Container>
            </RestrictedSection>
        )
    }
}

// Advanced filters live in the URL; no page-owned presets are needed here (the
// old Billing Management list had no default filter applied).
export default function FinancialAccountListContainerWithFilters(props) {
    const [advancedFilters, setAdvancedFilters] = useAdvancedFilters()
    return <FinancialAccountListContainer {...props} advancedFilters={advancedFilters} setAdvancedFilters={setAdvancedFilters} />
}
